module.exports = __webpack_public_path__ + "static/media/4.36e376a4.svg";